import { fieldValidationMessages } from 'app/constants';

export const noteFormErrorMessages = {
  errors: {
    note: {
      maxLength: (props: [string, { maxLength: number }]) => {
        return fieldValidationMessages.MAX_CHAR(props[1].maxLength);
      },
    },
  },
};
